<div [ngClass]="{ 'popup-container': isCellEditorPopup }">
  <app-number-field
    #fieldComponent
    [form-control]="formControl"
    [field]="cellParams.field"
  ></app-number-field>
</div>
